export default __webpack_public_path__ + "static/media/welcomeLandingbg-general2024.ac0a1779.png";